import React, {Component} from 'react'
// import { Link, Switch, Route } from 'react-router-dom'
import {Link} from 'react-router-dom'
import 'react-select/dist/react-select.css'
import Header from '../components/Header'
import Footer from '../components/Footer'
import UserOrLogin from './UserOrLogin'
import * as UrlHelpers from '../helpers/urlHelpers'

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gyms: [],
    }
  }

  componentDidMount() {
    // let url = "gyms/blate/walls/55/wall.jpg"
    // let downloadUrl = "https://firebasestorage.googleapis.com/v0/b/blate-app.appspot.com/o/gyms%2Fblate%2Fwalls%2F55%2Fwall.jpg?alt=media&token=78b642be-e7f6-4230-9e5b-8ac620077383"
    // let storage = window.firebase.storage()
    // let imageRef = storage.ref(url)
    // imageRef.getDownloadURL().then(function(url2) {
    //   console.info("SUCCESS")
    //   // `url` is the download URL for 'images/stars.jpg'
    //   // This can be downloaded directly:
    //   var xhr = new XMLHttpRequest();
    //   xhr.responseType = 'blob';
    //   xhr.onload = function(event) {
    //     var blob = xhr.response;
    //   };
    //   xhr.open('GET', url2);
    //   xhr.send();
    //   // Or inserted into an <img> element:
    //   var img = document.getElementById('image-test');
    //   img.src = url2;
    // }).catch(function(error) {
    //   // Handle any errors
    //   console.info("ERROR:")
    //   console.info(error)
    // });
  }

  getGyms = () => {
    let data = []
    window.firebaseDb.collection('gyms').onSnapshot(snapshot => {
      console.info(snapshot)
      window.s = snapshot
      if (snapshot.empty) {
        return data
      } else {
        data = snapshot.docs.map(function (documentSnapshot) {
          // TODO: deep clone?
          return Object.assign({}, documentSnapshot.data())
        })
        console.info(data)
        this.setState({
          gyms: data,
          loading: false,
        })
      }
    })
  }

  render() {
    return (
      <div>
        <div className="container homepage-image">
          <Header>
            <UserOrLogin />
          </Header>
          <h1 className="full-width center-text">Climbing app for woodies</h1>
          <div>
            <Link className="no-decoration" to={UrlHelpers.gymsPath}>
              <div
                className="white"
                style={{
                  padding: '10px 10px',
                  border: '1px white solid',
                  borderRadius: '4px',
                }}>
                Browse Gyms
              </div>
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.jsx